import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e3c6f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-bg-[white] tw-w-[100%] tw-h-[100%] tw-rounded-[6px] box-shadow-contain" }
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[70px] tw-h-[70px] tw-rounded-[6px]"
}
const _hoisted_3 = {
  key: 2,
  class: "custom-global-skeleton tw-w-[300px] tw-h-[70px] tw-rounded-[6px]"
}
const _hoisted_4 = { class: "tw-text-[25px] tw-leading-[23px] tw-w-[300px]" }
const _hoisted_5 = { class: "tw-text-[25px] tw-leading-[23px] tw-w-[300px]" }
const _hoisted_6 = {
  key: 1,
  class: "tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] tw-w-[70px] bg-skeleton"
}
const _hoisted_7 = { class: "md:tw-flex tw-w-full tw-justify-between md:tw-mb-[0px]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = { class: "tw-flex-shrink-0" }
const _hoisted_10 = { class: "tw-mb-[12px] tw-leading-[19px] tw-text-[13px] tw-text-[#211F58] tw-font-semibold md:tw-mt-[0px] tw-mt-[10px]" }
const _hoisted_11 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[2000px] tw-min-w-0 tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_12 = {
  id: "vendor-assess-external-input-interview",
  class: "tw-bg-[white] xl:tw-pt-[50px] xl:tw-pb-[55px] xl:tw-px-[60px] tw-p-[20px]"
}
const _hoisted_13 = { class: "tw-w-full tw-items-center tw-flex tw-justify-between tw-mb-[20px]" }
const _hoisted_14 = { class: "tw-mb-[0]" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  id: "vendor-assessments-input-header-popover",
  class: "tw-w-[46px] tw-h-[44px] tw-items-center tw-flex tw-justify-center",
  style: {"border-radius":"6px","border":"1px solid var(--UI-rule, #eff0f1)","background":"var(--UI-white, #fff)","box-shadow":"0px 0px 4px 0px rgba(0, 0, 0, 0.05)"}
}
const _hoisted_17 = {
  key: 1,
  id: "vendor-assess-external-input-description",
  class: "tw-bg-[#F2F8FF] tw-p-[20px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_18 = { class: "tw-text-[15px] tw-font-400 tw-text-[#231F20]" }
const _hoisted_19 = {
  key: 2,
  class: "tw-grid tw-grid-cols-2 vendor-card-container tw-mt-[20px] tw-gap-[20px]"
}
const _hoisted_20 = { class: "vendor-card tw-col-span-2 md:tw-col-span-1" }
const _hoisted_21 = {
  key: 1,
  class: "custom-global-skeleton tw-bg-[#ffffff] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_22 = { class: "vendor-card tw-col-span-2 md:tw-col-span-1" }
const _hoisted_23 = {
  key: 1,
  class: "custom-global-skeleton tw-bg-[#ffffff] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_24 = {
  key: 3,
  id: "vendor-assess-external-input-notes",
  class: "tw-bg-[#FCFCFD] tw-mt-[20px] tw-p-4 tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_25 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-[600] tw-leading-[130%]" }
const _hoisted_26 = { class: "tw-text-[#231F20] tw-text-[15px] tw-font-[400]" }

import VendorBasicPage from "./vendorBasicPage.vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import CyberSystem from "@/components/svgs/cyberSystem.vue";
import OrgAvatar from "@/components/share/orgAvatar.vue";
import VendorCard from "@/components/assessments/vendorCard.vue";
import PopoverAssessment from "@/components/assessment/popoverAssessment.vue";
import VendorAssessmentQuestions from "@/components/vendor/vendorAssessmentQuestions.vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import store from "@/store";
import VendorStatusCard from "@/components/vendor/vendorStatusCard.vue";
import { localStorageKey } from "@/utils/constants";
import { load } from "recaptcha-v3";
import NoteInfo from "@/components/common/noteInfo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentsInput',
  props: {
  orgDetail: {
    type: Object,
    required: true,
    default: () => ({
      nameLegal: "Name Legal",
      logoImageSrc: "",
    }),
  },
  text1: {
    type: String,
    required: true,
    default:
      "This is the description ut id arcu cursus, egestas felis at, rhoncus tortor. Pellentesque vitae massa nulla. Suspendisse eros lectus, cursus et orci non, posuere condimentum erat. ",
  },
  note: {
    type: String,
    required: true,
    default:
      "This is the description ut id arcu cursus, egestas felis at, rhoncus tortor. Pellentesque vitae massa nulla. Suspendisse eros lectus, cursus et orci non, posuere condimentum erat. ",
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const fetchData = async () => {
  store.dispatch("Vendor/fetchChecklistRequestedComplianceTypeValues", "clr");
  store.dispatch("Vendor/fetchChecklistRequestedComplianceTypeValues", "clra");
  await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
};



const notInfoVisible = ref(true);
const isGettingStatus = ref(true);
const imgOrgLogo = ref<string | null>(null);

const vendor = reactive({
  name: "",
  recipient: "",
  expiryDate: "",
  recipientFirstName: "",
  recipientLastName: "",
});

const isLoadingRequestedInput = computed(
  () => store.state.Vendor.isLoadingRequestedInput,
);

const vendorChecklistVendorRequested = computed(
  () => store.state.Vendor.checklistVendorRequestedExternalInput,
);

const isCheckStatusInprogAndWait = computed(
  () => store.getters["Vendor/isCheckStatusInprogAndWait"],
);

const assessmentQuestionTypes = computed(() => {
  return store.state.Vendor.checklistComplianceTypeValuesClra;
});

const passedReviewTotal = computed(() => {
  return (
    vendorChecklistVendorRequested.value.checklistRequestedItems?.filter(
      (item: any) => {
        let ComplianceTypeOrgValue: any;
        assessmentQuestionTypes.value.forEach((type: any) => {
          type.complianceTypeValues.forEach((value: any) => {
            if (value.id === item.checklistItemComplianceTypeValueOrgId) {
              ComplianceTypeOrgValue = value;
              return;
            }
          });
        });
        return (
          ComplianceTypeOrgValue?.value === 1 && !item.checklistItemIsHeading
        );
      },
    ).length ?? 0
  );
});

const titleText = computed(() => {
  const checklist = vendorChecklistVendorRequested.value || {};

  return getComponentUiText(
    "app-vendor-assessment-external-input-title-1",
    false,
    {
      checklistName: {
        value: checklist.name || "",
        css: "tw-font-[400]",
      },
    },
  );
});

const retrievePasswordIV = () => {
  return store.state.LanguagePicker.pwdFeIv;
};

const setLanguages = async () => {
  const passwordIV = retrievePasswordIV();
  if (
    localStorage.getItem(localStorageKey.languagesData) == null ||
    localStorage.getItem(localStorageKey.languageList) == null ||
    passwordIV === ""
  ) {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          this.$router.push({ path: "/" });
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }
};

watch(
  () => vendorChecklistVendorRequested.value,
  (value) => {
    if (Object.keys(value).length) {
      imgOrgLogo.value = value?.checklistRequestedEmailGrants[0]?.orgLogoFile
        ? `data:image/png;base64,${value?.checklistRequestedEmailGrants[0]?.orgLogoFile}`
        : null;
      vendor.name =
        value.providerName ||
        value.providerService ||
        value.checklistRequestedEmailGrants[0]?.orgName ||
        "-";
      vendor.recipient = value.checklistRequestedEmailGrants[0]?.recipientEmail;
      vendor.expiryDate = value.checklistRequestedEmailGrants[0]?.validUntil;
      vendor.recipientFirstName =
        value.checklistRequestedEmailGrants[0]?.firstName;
      vendor.recipientLastName =
        value.checklistRequestedEmailGrants[0]?.lastName;
    }
  },
  { immediate: true, deep: true },
);

onMounted(async () => {
  setLanguages();
  await fetchData();
  isGettingStatus.value = false;
  document.getElementById("app")?.classList.add("set-overflow-y-auto");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VendorBasicPage, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-rounded-t-[6px] tw-border-solid tw-border-t-[0px] tw-border-x-[0px] tw-border-b-[#EFF0F1] tw-border-b-[1px]  tw-justify-between sm:tw-flex tw-bg-[white] xl:tw-py-[60px] xl:tw-px-[60px] tw-p-[20px] ${
          __props.orgDetail?.logoImageSrc ? 'tw-items-center' : ''
        }`)
        }, [
          (__props.orgDetail)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`tw-flex ${imgOrgLogo.value ? 'tw-flex-col' : 'tw-h-[70px]'} ${
            imgOrgLogo.value ? 'tw-gap-[10px]' : 'tw-gap-[23.3px]'
          } 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px]`)
              }, [
                (!vendorChecklistVendorRequested.value?.orgName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                  : (_openBlock(), _createBlock(OrgAvatar, {
                      key: 1,
                      name: vendorChecklistVendorRequested.value?.orgName[0],
                      "src-img": imgOrgLogo.value ? imgOrgLogo.value : '',
                      "class-name": imgOrgLogo.value ? '!tw-h-[134px]' : '',
                      "img-class-name": '!tw-h-full'
                    }, null, 8, ["name", "src-img", "class-name"])),
                (!vendorChecklistVendorRequested.value?.orgName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["tw-flex tw-uppercase tw-tracking-wide tw-flex-col tw-gap-1 tw-justify-center tw-text-[#211F58] tw-font-semibold", __props.orgDetail?.logoImageSrc ? '' : 'tw-h-[70px]'])
                    }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(vendorChecklistVendorRequested.value?.orgName.split(" ")[0]), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(vendorChecklistVendorRequested.value?.orgName
                  .split(" ")
                  .slice(1)
                  .join(" ")), 1)
                    ], 2))
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_6)),
          _createElementVNode("div", {
            class: _normalizeClass(`2xl:tw-w-1/2 ${
            __props.orgDetail?.logoImageSrc ? 'tw-mb-[33px]' : ''
          }`)
          }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)("app-share-cyber-profile-powered-by-1")) + ": ", 1),
                _createElementVNode("div", null, [
                  _createVNode(CyberSystem)
                ])
              ])
            ])
          ], 2)
        ], 2),
        (__props.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _createElementVNode("span", {
                class: "tw-text-[32px] tw-font-[600] tw-text-[#211F58]",
                "data-cy": "vendor-checklist-requested-name",
                innerHTML: titleText.value
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(PopoverAssessment, {
                "id-popover": "popover-vendor-assessments-input-header-option",
                padding: "14px 13px",
                disable: true
              })
            ])
          ]),
          (
            notInfoVisible.value && !isCheckStatusInprogAndWait.value && !isGettingStatus.value
          )
            ? (_openBlock(), _createBlock(NoteInfo, {
                key: 0,
                "background-color": "#FE9A0526",
                class: "tw-mb-[20px]",
                onClose: _cache[0] || (_cache[0] = ($event: any) => (notInfoVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-vendor-assessment-external-input-flowing-banner-1",
              false,
              {
                orgName: vendorChecklistVendorRequested.value.orgName,
              },
            )), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (vendorChecklistVendorRequested.value.descriptionExternal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(vendorChecklistVendorRequested.value.descriptionExternal), 1)
              ]))
            : _createCommentVNode("", true),
          (!__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (!isLoadingRequestedInput.value)
                    ? (_openBlock(), _createBlock(VendorStatusCard, {
                        key: 0,
                        "is-show-tag": true,
                        "is-show-score": false,
                        status: {
                statusId: vendorChecklistVendorRequested.value.statusId,
                radialValue: (
                  vendorChecklistVendorRequested.value.completionPcnt * 100
                ).toFixed(),
                progress: {
                  completed: vendorChecklistVendorRequested.value.completion,
                  total: vendorChecklistVendorRequested.value.itemCountApplicable,
                  percent: parseFloat(
                    (
                      (vendorChecklistVendorRequested.value.completion /
                        vendorChecklistVendorRequested.value.itemCountApplicable) *
                      100
                    ).toFixed(),
                  ),
                },
                score: {
                  completed: passedReviewTotal.value,
                  total: vendorChecklistVendorRequested.value.itemCount,
                  percent: parseFloat(
                    (
                      (passedReviewTotal.value /
                        vendorChecklistVendorRequested.value.itemCount) *
                      100
                    ).toFixed(),
                  ),
                },
              },
                        "sub-text1": 
                _unref(getComponentUiText)(
                  'app-component-assessments-status-card-progress-1',
                )
              ,
                        "sub-text2": 
                _unref(getComponentUiText)(
                  'app-component-assessments-status-card-passed-review-1',
                )
              ,
                        class: "!tw-max-w-[2000px] !tw-h-[119px] tw-bg-white"
                      }, null, 8, ["status", "sub-text1", "sub-text2"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (!isLoadingRequestedInput.value)
                    ? (_openBlock(), _createBlock(VendorCard, {
                        key: 0,
                        vendor: vendor,
                        class: "!tw-max-w-[2000px] !tw-h-[119px] tw-bg-white"
                      }, null, 8, ["vendor"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23))
                ])
              ]))
            : _createCommentVNode("", true),
          (vendorChecklistVendorRequested.value.notesExternal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-instructions-title-1",
              )), 1),
                _createElementVNode("p", _hoisted_26, _toDisplayString(vendorChecklistVendorRequested.value.notesExternal), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(VendorAssessmentQuestions)
      ])
    ]),
    _: 1
  }))
}
}

})